import useValidator from 'utils/hooks/useValidator'
import { validateBasicCreative } from 'features/creative/add/basic/basicCreativeSlice'
import { validateThumbnail } from 'features/creative/add/asset/thumbnailSlice'
import { validateMultiThumbnail } from 'features/creative/add/asset/multiThumbnailSlice'
import { validateAdditionalTitle } from 'features/creative/add/asset/additionalTitleSlice'
import { validateAdditionalLink } from 'features/creative/add/asset/additionalLinkSlice'
import { validateSubject } from 'features/creative/add/asset/subjectSlice'
import { validatePriceTable } from 'features/creative/add/asset/priceTableSlice'
import { validateCalculate } from 'features/creative/add/asset/calculateSlice'
import { validatePhoneNumber } from 'features/creative/add/asset/phoneNumberSlice'
import { validateTalkChannel } from 'features/creative/add/asset/talkChannelSlice'
import { useSelector } from 'react-redux'
import { getFlattenObjectValueArray, isValidUrl } from 'utils'
import { BizChannelTypes } from '../../../Codes'
import { checkLegalNotice } from '../../creativeUtil'
import { validateThumbnailRecommend } from '../asset/thumbnailRecommendSlice'
import { validateThumbnailCustom } from '../asset/thumbnailCustomSlice'

export default () => {
  const { channel, creativeName, activeAssets } = useSelector(
    state => state.creative.buildCreative
  )
  const {
    basicCreative,
    thumbnail,
    multiThumbnail,
    additionalTitle,
    additionalLink,
    subject,
    priceTable,
    calculate,
    talkChannel,
    phoneNumber,
    thumbnailRecommend,
    thumbnailCustom,
  } = useSelector(state => ({
    ...state.creative.assets,
    ...state.creative,
  }))
  const bizChannelType =
    channel?.bizChannelType || BizChannelTypes.WEBSITE_BIZ_CHANNEL
  const isLegalNotice = checkLegalNotice(channel)

  const { errors, validate, clearError } = useValidator([
    () => ({
      creativeName: creativeName.trim() === '' && '소재 이름을 입력하세요.',
      basicCreative: validateBasicCreative(
        bizChannelType,
        basicCreative,
        channel.siteUrl
      ),
      ...(bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL && {
        thumbnail: validateThumbnail(activeAssets.thumbnail, thumbnail),
        multiThumbnail: validateMultiThumbnail(
          activeAssets.multiThumbnail,
          multiThumbnail,
          channel.siteUrl
        ),
        additionalTitle: validateAdditionalTitle(
          activeAssets.additionalTitle,
          additionalTitle
        ),
        additionalLink: validateAdditionalLink(
          activeAssets.additionalLink,
          additionalLink,
          channel.siteUrl
        ),
        subject: validateSubject(
          activeAssets.subject,
          subject,
          channel.siteUrl
        ),
        priceTable: validatePriceTable(
          activeAssets.priceTable,
          priceTable,
          channel.siteUrl
        ),
        calculate: validateCalculate(
          activeAssets.calculate,
          calculate,
          channel.siteUrl
        ),
        phoneNumber: validatePhoneNumber(activeAssets.phoneNumber, phoneNumber),
        talkChannel: validateTalkChannel(activeAssets.talkChannel, {
          ...talkChannel,
          talkChannelAccounts: channel.talkChannelAccounts,
        }),
      }),
      ...(bizChannelType === BizChannelTypes.TALK_CHANNEL && {
        thumbnailRecommend: validateThumbnailRecommend(
          isLegalNotice,
          basicCreative.licenseNumber,
          basicCreative.license,
          basicCreative.bothLegalNoticeChecked,
          thumbnailRecommend
        ),
        thumbnailCustom: validateThumbnailCustom(thumbnailCustom),
      }),
    }),
    prevErrors => ({
      ...prevErrors,
      anyError: getFlattenObjectValueArray(prevErrors).reduce(
        (res, curr) => res || curr
      ),
    }),
  ])

  return {
    errors,
    validate,
    clearError,
  }
}

export const validateLandingUrlWithSiteUrl = (
  { individual, mobileUrl, pcUrl },
  { individualSettingYn, pcSiteYn, mobileSiteYn }
) => {
  if (individualSettingYn === 'N' && individual) {
    return {
      mobileUrl:
        mobileUrl === ''
          ? '모바일 링크URL을 입력하세요.'
          : !isValidUrl(mobileUrl) && '정상적인 링크URL을 입력하세요.',
      pcUrl:
        pcUrl === ''
          ? 'PC 링크URL을 입력하세요.'
          : !isValidUrl(pcUrl) && '정상적인 링크URL을 입력하세요.',
    }
  } else if (individual) {
    return {
      mobileUrl:
        mobileSiteYn === 'Y'
          ? mobileUrl === ''
            ? '모바일 링크URL을 입력하세요.'
            : !isValidUrl(mobileUrl) && '정상적인 링크URL을 입력하세요.'
          : false,
      pcUrl:
        pcSiteYn === 'Y'
          ? pcUrl === ''
            ? 'PC 링크URL을 입력하세요.'
            : !isValidUrl(pcUrl) && '정상적인 링크URL을 입력하세요.'
          : false,
    }
  } else {
    return {
      mobileUrl:
        mobileUrl === ''
          ? '모바일 또는 PC 링크URL을 입력하세요.'
          : !isValidUrl(mobileUrl) && '정상적인 링크URL을 입력하세요.',
      pcUrl: false,
    }
  }
}
